import { Component, Input } from '@angular/core';
import { NgIf, NgForOf } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ResultData } from './search-result-list.component.types';
import { LoaderComponent } from '../loader/loader.component';
import { AssetVersionPipe } from '../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-search-result-list',
  imports: [NgIf, NgForOf, ScrollingModule, LoaderComponent, AssetVersionPipe],
  templateUrl: './search-result-list.component.html',
  styleUrls: ['./search-result-list.component.scss']
})
export class SearchResultListComponent {
  @Input() isLoading = false;
  @Input() results: ResultData[] | undefined;
  @Input() placeholder: string[] = [];
  @Input() resultClickCallback: Function | undefined;

  onAdd(result: ResultData): void {
    result.isSelected = true;
  }
}
